import React, { useEffect } from "react";
import { Navigate, useRoutes } from "react-router";
import { lazy } from "react";
import AdminPanelLayout from "../components/admin-panel/admin-panel-layout";
import Homes from "../pages/homes/Homes";
import Login from "../pages/authentication/Login";
import PrivateRoute from "../components/PrivateRoute";
import PublicRoute from "../components/PublicRoute";
import { useDispatch, useSelector } from "react-redux";
import UserService from "../services/user/user";
import { toastError } from "../components/ToastNotification";
import { setUser } from "../store/slices/userSlice";
import MyProfile from "../pages/my-profile/MyProfile";
import Organization from "../pages/organization/Organization";
import LandingPage from "../pages/LandingPage/LandingPage";
import LandingMaxLauout from "../components/LandingMaxLayout";
import UseCases from "../pages/UseCases/UseCases";
import TermsOfService from "../pages/TermsOfService/TermsOfService";
import Roadmap from "../pages/Roadmap/Roadmap";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import Contact from "../pages/Contact/Contact";
import Subscription from "../pages/subscription/Subscription";
import PaymentSuccess from "../pages/payment/PaymentSuccess";
import PaymentFailed from "../pages/payment/PaymentFailed";

const SuspenseLoader = (Component) => (props) =>
(
  <React.Suspense fallback={<withLoader />}>
    <Component {...props} />
  </React.Suspense>
);

function RedirectionWrapper({ to }) {
  const queryString = window.location.search;
  console.log("user111");
  if (queryString) {
    return <Navigate to={`${to}${queryString}`} />;
  }
  return <Navigate to={to} />;
}

const routes = (isLoggedin, isLoading, user) => [
  {
    path: "/",
    element: !isLoading && <LandingMaxLauout />,
    children: !isLoading && [
      {
        index: true,
        element: <LandingPage />,
      },
      {
        path: "/use-cases",
        element: <UseCases />,
      },
      {
        path: "/terms-of-service",
        element: <TermsOfService />,
      },
      {
        path: "/roadmap",
        element: <Roadmap />,
      },

      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />,
      },
      // {
      //   path: "/pricing",
      //   element: user?.users?.userType === "OrganizationUser" ? <Navigate to="/home" /> : <Subscription />,
      // },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/payment/success",
        element: <PaymentSuccess />,
      },
      {
        path: "/payment/fail",
        element: <PaymentFailed />,
      },
    ],
  },
  {
    path: "/",
    element: isLoggedin && <AdminPanelLayout />,
    children: isLoggedin && [
      {
        element: <RedirectionWrapper to="/home" replace />,
        index: true,
      },
      {
        path: "/home",
        element: (
          <PrivateRoute>
            <Homes />
          </PrivateRoute>
        ),
      },
      {
        path: "/profile",
        element: (
          <PrivateRoute>
            <MyProfile />
          </PrivateRoute>
        ),
      },
      {
        path: "/organization",
        element: (
          <PrivateRoute>
            <Organization />
          </PrivateRoute>
        ),
      },
      // {
      //   path: "/login",
      //   element: <Navigate to="/home" replace />,
      // },
    ],
  },
  {
    path: "/login",
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },
];

export default function Routes(props) {
  const dispatch = useDispatch();
  const isLogin = props?.isLoggedin;
  const isLoading = props?.isLoading;

  const getUserDetails = async () => {
    try {
      const response = await UserService?.getUserDetails();
      console.log("response", response)
      if (response) {
        dispatch(setUser({ ...response?.data?.data, tenantId: response?.data?.tenantId }));
      }
    } catch (error) {
      console.log("🚀  getUserDetails  error:", error);
    }
  };
  const user = useSelector((state) => state.user.user);

  console.log("user111", user);


  useEffect(() => {
    if (isLogin) {
      getUserDetails();
    }
  }, [isLogin]);

  const { isLoggedin } = props;
  return useRoutes(routes(isLoggedin, isLoading, user));
}
